import { render, staticRenderFns } from "./PurchaseItemList.vue?vue&type=template&id=9cc2b626&"
import script from "./PurchaseItemList.vue?vue&type=script&lang=js&"
export * from "./PurchaseItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports